import { queryOptions, useQuery } from '@tanstack/react-query'
import { QUERY_TIME_CONFIG } from '@omnea-app/fe-api-client/queryConfig'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { UsersHttpClient } from '@omnea-app/users/usersHttpClient'
import { listGroupsQueryKey } from './groupsQueryKeys'

export const listGroupsQueryOptions = (getToken: () => Promise<string>) =>
  queryOptions({
    queryKey: [listGroupsQueryKey],
    queryFn: async () => {
      const token = await getToken()
      const apiClient = new UsersHttpClient({ omneaJwt: token })
      const { data } = await apiClient.GET('/groups/list')
      return data
    },
  })

export const useListGroups = () => {
  const { getToken } = useAuthenticatedUser()
  // Set here rather than on the shared options, for the reason given in useViewableGroupIds:
  // a mutation reads the options' key back, and a stale write would revert a rename.
  return useQuery({ ...listGroupsQueryOptions(getToken), staleTime: QUERY_TIME_CONFIG.REFERENCE_DATA_STALE_TIME })
}
